import { AnalyticsWindow } from "./analytics-window"
import setUserProperties from "./analytics-identify"

declare let window: AnalyticsWindow

function get6senseData() {
  const localStorageString = window.localStorage.getItem(
    "_6senseCompanyDetails",
  )
  const localStorageData = JSON.parse(localStorageString || "{}")

  const companyDetails = localStorageData?.company || {}
  const segmentDetails = localStorageData?.segments || {}
  let data = {
    Company: companyDetails.name,
    Industry: companyDetails.industry,
    "Employee count": companyDetails.employee_count,
    "Employee range": companyDetails.employee_range,
    "Annual revenue": companyDetails.annual_revenue,
    Title: companyDetails.titleLevel,
    Function: companyDetails.titleFunction,
    "Revenue range": companyDetails.revenue_range,
    "HQ region": companyDetails.region,
    Segments: segmentDetails.names,
  }
  const filteredData = Object.entries(data).reduce(
    (acc: Record<string, any>, [key, value]) => {
      if (value && value.length > 0) {
        acc[key] = value
      }
      return acc
    },
    {},
  )
  return { "6sense": [filteredData] }
}

async function set6senseDataOnUserProperty() {
  const maxRetries = 30
  async function wait(t: number) {
    return new Promise(resolve => setTimeout(resolve, t))
  }

  let retries = 0
  while (retries < maxRetries) {
    if (window.localStorage.getItem("_6senseCompanyDetails")) {
      const data = get6senseData()
      setUserProperties(data)
      return
    }
    await wait(100)
    retries++
  }
}

export { set6senseDataOnUserProperty }
export default get6senseData
